import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20modern%20abstract%20cinematic%20composition%20with%20flowing%20geometric%20shapes%20in%20warm%20orange%20and%20deep%20charcoal%20tones%2C%20soft%20curved%20lines%20representing%20motion%20and%20entertainment%2C%20theater%20curtain%20abstract%20texture%2C%20elegant%20minimalist%20design%20with%20dramatic%20lighting%2C%20no%20text%2C%20no%20logos%2C%20dark%20moody%20background%20with%20warm%20highlights&width=1920&height=1080&seq=hero-bg-mushroom-video&orientation=landscape"
          alt="蘑菇视频 - 高清视频平台"
          className="w-full h-full object-cover object-center"
          title="蘑菇视频官网 - 官方正版视频平台入口"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
          <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
          <span className="text-sm text-background-50/90">
            海量高清视频 · 官方正版平台
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-background-50 mb-6 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
          蘑菇视频
          <span className="block text-2xl md:text-3xl font-normal mt-2 text-background-300" style={{ fontFamily: "var(--font-body)" }}>
            您的专属高清视频平台
          </span>
        </h1>

        <p className="text-base md:text-lg text-background-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          汇聚海内外优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等丰富内容。
          蘑菇视频官网支持多端同步观看，4K超清画质，杜比全景声，为您打造沉浸式观影体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-play-circle-fill mr-2"></i>
            立即观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-background-400/50 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-smartphone-line mr-2"></i>
            下载蘑菇视频APP
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">5000<span className="text-primary-400">+</span></div>
            <div className="text-xs text-background-400 mt-1">优质内容</div>
          </div>
          <div className="w-px h-10 bg-background-500/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">2<span className="text-primary-400">亿+</span></div>
            <div className="text-xs text-background-400 mt-1">活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-500/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">4K</div>
            <div className="text-xs text-background-400 mt-1">超清画质</div>
          </div>
          <div className="w-px h-10 bg-background-500/30"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">99.9<span className="text-primary-400">%</span></div>
            <div className="text-xs text-background-400 mt-1">用户好评</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-400 text-2xl"></i>
      </div>
    </section>
  );
}